
import { clientType } from './types'
import clientTypeData from "../../data/clientTypeData.json";

export class clientTypeService {
  async getClientTypeList(): Promise<clientType[]> {
    const data = clientTypeData.data
    return data;
  }
}